var map = {
	"./calendar-check-icon.svg": "60d3",
	"./calendar-filter.svg": "e195",
	"./chair-filter.svg": "f1d6",
	"./chair-icon.svg": "4de2",
	"./closed-booking-icon.svg": "33ae",
	"./closure.svg": "5a84",
	"./count-place-icon.svg": "bdf2",
	"./location.svg": "c02e",
	"./not-read.svg": "3efb",
	"./paid-filter.svg": "39f7",
	"./stat-arrow.svg": "8246",
	"./time-closure-icon.svg": "f575",
	"./time-filter.svg": "97a4",
	"./time-new-icon.svg": "ddec",
	"./time-wait-icon.svg": "edd1",
	"./timer-icon.svg": "45bf",
	"./to-close-icon.svg": "31ab"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c547";